















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class FormFieldsContainer extends Vue {
  @Prop({}) titulo: string;
  @Prop({ default: false }) column: boolean;
}
